import { mapActions } from 'vuex';
import moment from 'moment';
import getIDfromURL from '../getIDfromURL';

export default {
  components: {},
  data() {
    return {
      userInfo: {
        user: {},
        display_configuration: {},
        friendship_status: '',
        follow_status: '',
      },
      owner: '',
      networkModalText: '',
      congratulationModalShow: false,
      chatRoomId: null,
      page: 1,
    };
  },
  methods: {
    ...mapActions({
      fetchUserPublicInfo: 'user/fetchUserPublicInfo',
      addToNetwork: 'user/userInvitationRequest',
      follow: 'network/follow',
      unFollowMember: 'network/unFollowMember',
      conversationList: 'messages/getConversationList',
      createNewConversation: 'messages/createNewConversation',
    }),
    async getChatRoomId() {
      const { result } = await this.conversationList({
        conversationId: '',
        page: this.page,
      });
      result.docs.filter((res) => {
        if (res.receiver_id !== this.userInfo.id && result.docs.length) {
          for (let i = 2; i < result.docs.length; i += 1) {
            this.conversationList({
              conversationId: '',
              page: (this.page += 1),
            }).then(myRes => myRes.result.docs.filter((myResp) => {
              if (myResp.receiver_id === this.userInfo.id) {
                this.chatRoomId = res.chat_room_id;
              } else {
                return null;
              }
              return null;
            }));
          }
        } else {
          this.chatRoomId = res.chat_room_id;
        }
        return null;
      });
    },
    async sendMsg() {
      if (this.chatRoomId) {
        this.$router.push({
          name: 'currentMessage',
          params: {
            chatRoomId: this.chatRoomId,
          },
        });
      } else {
        try {
          const { result } = await this.createNewConversation({
            receiver_id: this.userInfo.user.id,
          });
          this.$router.push({
            name: 'currentMessage',
            params: {
              chatRoomId: result.chat_room_id,
              user: this.userInfo,
            },
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    async followReq() {
      if (!this.userInfo.follow_status.following) {
        try {
          const data = await this.follow({
            follower: this.owner.url,
            following: this.userInfo.url,
          });
          this.userInfo.follow_status.following_url = data.url;
          this.userInfo.follow_status.following = true;
          this.congratulationModalShow = true;
          this.networkModalText = `You are now following ${this.userInfo.user.first_name} ${this.userInfo.user.last_name}.`;
          this.$notify({
            group: 'profile',
            title: 'success',
            text: 'Member have been added to your followers list!',
            type: 'success',
          });
        } catch (e) {
          if (e) {
            this.networkModalText = '';
            this.congratulationModalShow = false;
            this.$notify({
              group: 'profile',
              title: 'error',
              text: `${e.name}`,
              type: 'error',
            });
          }
        }
      }
    },
    async UnFollowReq() {
      if (this.userInfo.follow_status.following_url) {
        try {
          await this.unFollowMember(this.userInfo.follow_status.following_url);
          this.userInfo.follow_status.following = false;
          this.$notify({
            group: 'profile',
            title: 'success',
            text: 'Member have been deleted from your followers list!',
            type: 'success',
          });
        } catch (err) {
          this.$notify({
            group: 'profile',
            title: 'error',
            text: `${err.name}`,
            type: 'error',
          });
        }
      }
    },
    async toNetwork() {
      try {
        await this.addToNetwork({
          requested_by: this.owner.url,
          requested_to: this.userInfo.url,
        });
        this.$notify({
          group: 'profile',
          title: 'success',
          text: 'Friend request has been sent!',
          type: 'success',
        });
        this.congratulationModalShow = true;
        this.networkModalText = `
          Your Network request has been successfully sent to
          ${this.userinfo.user.first_name} ${this.userinfo.user.last_name}.`;
      } catch (e) {
        if (e) {
          this.$notify({
            group: 'profile',
            title: 'error',
            text: `${e.message}`,
            type: 'error',
          });
          this.networkModalText = '';
          this.congratulationModalShow = false;
        }
      }
    },
    moment(date) {
      return moment(new Date(date));
    },
    getId(url) {
      return getIDfromURL(url);
    },
  },
  async created() {
    const { customerId } = this.$route.params;
    try {
      this.userInfo = await this.fetchUserPublicInfo(customerId);
      this.owner = await this.fetchUserPublicInfo();
    } catch (err) {
      this.$router.push({ name: 'NotFound' });
    }
  },
};
